module.exports = __webpack_public_path__ + "img/peopleCount_preview.1df96168.png";